import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.363 24c0 7.532 6.105 13.636 13.637 13.636S37.636 31.532 37.636 24c0-7.532-6.105-13.636-13.636-13.636-7.533 0-13.637 6.104-13.637 13.636ZM9 24c0-8.285 6.714-15 15-15 8.285 0 15 6.715 15 15s-6.715 15-15 15S9 32.285 9 24Zm6.903 0A8.096 8.096 0 0 1 24 15.904 8.096 8.096 0 0 1 32.097 24 8.096 8.096 0 0 1 24 32.097 8.096 8.096 0 0 1 15.903 24Z",
    fill: "currentColor"
  }));
};

var SvgRecordingLive = styled(SvgComponent).withConfig({
  displayName: "RecordingLive__SvgRecordingLive",
  componentId: "sc-hzd15d-0"
})(["", " ", ""], size, color);
export default SvgRecordingLive;